import React from "react";
import Uppy from "@uppy/core";
import AwsS3Multipart from "@uppy/aws-s3-multipart";
import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";
import { DashboardModal } from "@uppy/react";

import UppyPluginGetPresigned from "../../lib/uppyPluginGetPresigned";

const Upload = ({ meta, open, onClose }) => {
  const uppy = React.useMemo(() => {
    let uppy = new Uppy({
      restrictions: {
        allowedFileTypes: ["image/*", "video/*"],
      },
      meta: {
        ...meta,
      },
      logger: Uppy.debugLogger,
    })
      .use(UppyPluginGetPresigned, {})
      .use(AwsS3Multipart, { limit: 4, companionUrl: `/api/media/companion` });

    // uppy.on("complete", (result) => {
    //   const url = result.successful[0].uploadURL;
    //   store.dispatch({
    //     type: "SET_USER_AVATAR_URL",
    //     payload: { url: url },
    //   });
    // });

    uppy.on("upload-success", (file, data) => {
      // console.log("Upload-success!!");
      // file.meta["key"]; // the S3 object key of the uploaded file

      fetch(`/api/media/complete/${file.meta.mediaRand}`, {
        method: "POST",
      })
        .then((body) => {
          // console.log("response after uploaded media:", body);
        })
        .catch((err) => {
          console.error("Fetch error:", err);
        });
    });

    return uppy;
  }, [meta]);
  React.useEffect(() => {
    return () => uppy.close();
  }, []);

  return (
    <div>
      {/* <img src={currentAvatar} alt="Current Avatar" /> */}
      <DashboardModal
        open={open}
        onRequestClose={onClose}
        uppy={uppy}
        // locale={{
        //   strings: {
        //     // Text to show on the droppable area.
        //     // `%{browse}` is replaced with a link that opens the system file selection dialog.
        //     dropHereOr: "Drop here or %{browse}",
        //     // Used as the label for the link that opens the system file selection dialog.
        //     browse: "browse",
        //   },
        // }}
      />
    </div>
  );
};
export default Upload;
